import React from "react";
import { CheckCircle2, HelpCircle } from "lucide-react";

export const ManualInfo = ({ content }) => {
  if (!content) return null;
  return (
    <section data-testid="manual-info" className="mt-14">
      <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#1A1A1A]">{content.heading}</h2>
      <div className="mt-5 space-y-4">
        {content.paragraphs.map((p, i) => (
          <p key={i} className="text-lg leading-relaxed text-[#4A4A4A]">{p}</p>
        ))}
      </div>

      <h3 className="font-heading text-2xl font-bold text-[#1A1A1A] mt-10">{content.learnTitle}</h3>
      <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-3">
        {content.learn.map((item) => (
          <li key={item} className="flex items-start gap-3 text-lg text-[#1A1A1A]">
            <CheckCircle2 className="text-[#0B7A3F] shrink-0 mt-1" size={22} strokeWidth={2.5} /> {item}
          </li>
        ))}
      </ul>

      <h3 className="font-heading text-2xl font-bold text-[#1A1A1A] mt-10">Vanliga frågor</h3>
      <div className="mt-5 space-y-5">
        {content.faqs.map((f) => (
          <div key={f.q} className="bg-white border-2 border-gray-200 rounded-xl p-6">
            <p className="font-heading text-xl font-bold text-[#1A1A1A] flex items-start gap-2">
              <HelpCircle size={24} strokeWidth={2.5} className="text-[#0056D2] shrink-0 mt-0.5" /> {f.q}
            </p>
            <p className="text-lg text-[#4A4A4A] mt-2 leading-relaxed">{f.a}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
